var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4DoorHandle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v6H34.79a3 3 0 01-3-3.56A3.1 3.1 0 0134.94 24H62zM34.79 34H46v33H22V10h24v10H34.94a7.06 7.06 0 00-7 5.73A7 7 0 0034.79 34zM34 45.41a3.91 3.91 0 00-1.88 7.35L30.74 61H37l-1.36-8.16A3.92 3.92 0 0034 45.41z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Door_handle.cf761656.svg";
export { SvgE4DoorHandle as ReactComponent };